module.exports = __webpack_public_path__ + "static/media/fast_cooking_icon.dda156aa.svg";